import React, {useEffect, useContext} from 'react'
import { TitleContext, PathContext } from "../../Context";
export const pageUrl = () => "/node-js/mongodb-limit-document";

export default function MongoDbLimitDocument() {

    const title = useContext(TitleContext);
    const path = useContext(PathContext);
    useEffect(() => {
        title.setPageTitle("Node Js - MongoDB - Limit Document | Aspirant's Home");
        const urls = {
            'previous': '/node-js/mongodb-update-document',
            'next': '/node-js/mongodb-join-document'
        }
        path.setPreviousNext(urls);
    }, [])
    
    return (
        <section className='mt-5 mb-5'>
            <h3>Node Js MongoDB Limit Document</h3>
            <div className='mt-4'>
                <p>To limit the result, we use <strong>`limit()`</strong> method. The <strong>`limit()`</strong> method takes one parameter, a number defining how many documents to return.</p>
                <p>Ok, lets take an example document like below</p>
                <div className='codePalateBox mt-2 mb-2'>
                    <div className='codePalate' dangerouslySetInnerHTML={{
                        __html:
                            `<p>[</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a80 , employee_name: "Sudhir", email: "sudhir@gmail.com" },</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a81, employee_name: "Pradip", email: "pradip@gmail.com" },</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a82, employee_name: "Rachel", email: "rachel@gmail.com" },</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a83, employee_name: "Benjamin", email: "benjamin@gmail.com" },</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a84, employee_name: "Samantha", email: "samantha@gmail.com" },</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a85, employee_name: "Charlotte", email: "charlotte@gmail.com" },</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a86, employee_name: "Gregg", email: "gregg@gmail.com" },</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a87, employee_name: "Stacie", email: "stacie@gmail.com" },</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a88, employee_name: "Eleanor", email: "eleanor@gmail.com" },</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a89, employee_name: "Horton", email: "horton@gmail.com" },</p>
                            <p>]</p>`
                    }}>
                    </div>
                </div>
                <p>Now limit the result to 5, then we have to pass 5 in limit() method. Check in the below example.</p>
                <div className='codePalateBox mt-2 mb-2'>
                    <div className='codePalate' dangerouslySetInnerHTML={{
                        __html:
                            `<p><span class='color-blue'>var</span> MongoClient = <span class='color-yellow'>require</span>(<span class='color-green'>'mongodb'</span>).MongoClient;</p>
                            <p><span class='color-blue'>var</span> url = <span class='color-green'>"mongodb://localhost:27017/"</span>;</p>
                            <br />
                            <p>MongoClient.<span class='color-red'>connect</span>(<span class='color-blue'>url</span>, function(err, db) {</p>
                            <p style='margin-left:30px'>  <span class='color-blue'>if</span> (err) throw err;</p>
                            <p style='margin-left:30px'>  <span class='color-blue'>var</span> dbo = db.<span class='color-red'>db</span>(<span class='color-green'>"mymongodbdatabase"</span>);</p>
                            <p style='margin-left:30px'>  dbo.<span class='color-red'>collection</span>(<span class='color-green'>"employees"</span>).find().limit(5).toArray(<span class='color-blue'>function</span>(err, result) {</p>
                            <p style='margin-left:60px'>    <span class='color-blue'>if</span> (err) <span class='color-blue'>throw</span> err;</p>
                            <p style='margin-left:60px'>    <span class='color-pink'>console</span>.<span class='color-red'>log</span>(result);</p>
                            <p style='margin-left:60px'>    db.<span class='color-red'>close</span>();</p>
                            <p style='margin-left:30px'>  });</p>
                            <p>});</p>`
                    }}>
                    </div>
                </div>
                <p>Which will give you this result:</p>
                <div className='codePalateBox mt-2 mb-2'>
                    <div className='codePalate' dangerouslySetInnerHTML={{
                        __html:
                            `<p>[</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a80 , employee_name: "Sudhir", email: "sudhir@gmail.com" },</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a81, employee_name: "Pradip", email: "pradip@gmail.com" },</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a82, employee_name: "Rachel", email: "rachel@gmail.com" },</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a83, employee_name: "Benjamin", email: "benjamin@gmail.com" },</p>
                            <p style='margin-left:30px'> { _id: 58fdbf5c0ef8a50b4cdd9a84, employee_name: "Samantha", email: "samantha@gmail.com" },</p>
                            <p>]</p>`
                    }}>
                    </div>
                </div>
            </div>
        </section>
    )
}
